(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/primary-onboarding/assets/javascripts/hint-item.js') >= 0) return;  svs.modules.push('/templates/primary-onboarding/assets/javascripts/hint-item.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  verifyObject
} = svs.components.lbUtils.verify;
const {
  log: logger
} = svs.components.lbUtils.onboarding;
const {
  hintVerifyType,
  HintVisibility,
  hintLogicFields,
  baseHintItem
} = svs.templates.primaryOnboarding.constants;
const {
  checkChanges
} = svs.templates.primaryOnboarding.utils;
const {
  setOnboardingInfo
} = svs.templates.primaryOnboarding.onboardingInfo;
const {
  setItem,
  getItem
} = svs.templates.primaryOnboarding.sessionStorage;

const knownHintKeysKey = 'knownHintKeys';
const knownHints = getItem(knownHintKeysKey) || [];
const writeHintToSession = hint => {
  if (!knownHints.includes(hint.key)) {
    knownHints.push(hint.key);
    setItem(knownHintKeysKey, knownHints);
  }
  setItem(hint.key, {
    hasTriggered: hint.hasTriggered
  });
};
const getHintFromSession = key => getItem(key);
const setHintToOnboardingInfo = hint => {
  try {
    verifyObject(hint).schema(hintVerifyType);
    writeHintToSession(hint);
    setOnboardingInfo(hint.key, hint);
  } catch (err) {
    logger.debug('Failed to set hint to onboarding info', err);
  }
};
const createHintItem = props => {
  for (const key in props) {
    if (!(key in baseHintItem)) {
      delete props[key];
    }
  }
  const sessionHint = getHintFromSession(props.key) || {};
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseHintItem), props), hintLogicFields), sessionHint);
};
const addNewHint = hint => {
  try {
    const hintItem = createHintItem(hint);
    verifyObject(hintItem).schema(hintVerifyType);
    const {
      hasTriggered
    } = getHintFromSession(hintItem.key) || {
      hasTriggered: hintItem.hasTriggered
    };
    setHintToOnboardingInfo(_objectSpread(_objectSpread({}, hintItem), {}, {
      hasTriggered
    }));
  } catch (err) {
    logger.debug('Failed to add new hint', err);
  }
};
let hintHooks = {};
const registerHintHooks = hooks => {
  hintHooks = _objectSpread(_objectSpread({}, hintHooks), hooks);
};
const triggerHintHooks = (oldHint, newHint) => {
  const changes = checkChanges(oldHint, newHint);
  if (changes.size > 0) {
    changes.forEach((_ref, key) => {
      let {
        oldValue,
        newValue
      } = _ref;
      if (hintHooks[key]) {
        hintHooks[key](oldValue, newValue, oldHint, newHint);
      }
    });
  }
};
const updateHintWithChanges = (hint, changes) => {
  const newHint = _objectSpread(_objectSpread({}, hint), changes);
  const changesKeys = Object.keys(changes);
  if (changesKeys.includes('isVisible') || changesKeys.includes('isAvailable')) {
    if (newHint.isVisible && newHint.isAvailable) {
      newHint.visibility = HintVisibility.Visible;
    } else if (newHint.isAvailable) {
      newHint.visibility = HintVisibility.Available;
    } else {
      newHint.visibility = HintVisibility.None;
    }
  }
  setHintToOnboardingInfo(newHint);
  triggerHintHooks(hint, newHint);
};

setGlobal('svs.templates.primaryOnboarding.hintItem', {
  addNewHint,
  updateHintWithChanges,
  registerHintHooks
});

 })(window);